export default __webpack_public_path__ + "static/media/Ecommerce.4d29d454.svg";